// used to make sure all environments have same properties
import {
  HostEnvironment,
  PaldeskRemoteVersions,
} from '@paldesk/module-federation/core';
import { HeaderTestRemoteVersion } from '@paldesk/module-federation/remotes-registry';

export class EnvironmentBase {
  static remotes: PaldeskRemoteVersions = {
    ...HeaderTestRemoteVersion,
  };
  static disable_spotlights = false;
  static disable_satisfaction_survey = false;
  static buildId = '';
  static environment: HostEnvironment = 'dev';
  static palfinger_api_management = '';
  static palfinger_api_management_subs_key = '';
  static palfinger_app_gateway = '';
  static bpm_base_path = '';
  static scc_base_path = '';
  static solutions_config_base_path = '';
  static wiki_base_path = '';
  static oidc_clientid = '';
  static oidc_scope = '';
  static scc_domain = '';
  static palshow_domain = '';
  static cart_max_valid_until_days = 548;
  static geo_json_url = '';
  static blob_storage_base_path = '';

  static LINKS: {
    SECURITY_TOKEN_SERVICE: string;
    POST_LOGOUT_REDIRECT_URI: string;
    PALDESK_BASEPATH: string;
    STATUS_PALDESK_PAGE: string;
    APP_HELP_PATH: string;
    APP_NEWS_PATH: string;
  } = {
    SECURITY_TOKEN_SERVICE: '',
    POST_LOGOUT_REDIRECT_URI: '',
    PALDESK_BASEPATH: '',
    STATUS_PALDESK_PAGE: '',
    APP_HELP_PATH: '',
    APP_NEWS_PATH: '',
  };

  static domainsForApiManagementSubsKey: string[];

  static identityServerAuthConf: {
    whitelistedDomains: string[];
    whitelistedRoutes: string[];
  } = {
    whitelistedDomains: [],
    whitelistedRoutes: [],
  };

  static google_api_key = '';
  static google_analytics_id = '';
  static application_insights_key = '';

  static FEATUREFLAGS: any = {
    SERVICE_CONTRACTS: true,
    SCC_CONTRACT_COMPONENT: 'NONE',
    BULK_ORDERS: false,
    BENEFITS: false,
    VIEW_3D: false,
    EARLY_ACCESS: false,
    PPI: false,
    MCC: false,
    PALSHOW: '',
    WHOLESALE_CHECKBOX: false,
    PROJECT_SETTINGS: false,
    SOLUTIONS_INTEGRATION: false,
    REPORTING: false,
    BEST_INVEST: '',
    BEST_INVEST_CALCULATION_DETAILS: false,
    BEST_INVEST_CHAT: 'NONE',
    DIGITAL_OFFER: '',
    MODEL_COMPARISON: '',
    DELIVERY_TIME: '',
    MODEL_COMPARISON_VARIANT_DIAGRAMS: '',
    SEGMENTS: '',
    COMBI_OFFER: '',
    CALCULATION_REDESIGN: '',
    VR_READY_BADGE: '',
    CHASSIS_BODY_PLATFORM: 'NONE',
    EQUIPMENT_UPSELLING: 'NONE',
    AZURE_AI_SEARCH_CUSTOM_ARTICLES: 'NONE',
    UNIFIED_CUSTOM_ARTICLE_VIEW: 'NONE',
    MARKET_INSIGHTS: 'NONE',
  };

  static VR_READY: {
    PRODUCT_NAMES: string[];
    SALES_OPTION_NAMES: string[];
  } = {
    PRODUCT_NAMES: [],
    SALES_OPTION_NAMES: [],
  };

  static privileged_users: string[] = [];
}
